import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Image } from "react-bootstrap";
import "./index.css";
import "./userCompanyInfo.css";
import { useDialog } from "../../../../helpers/useDialog";
import { useDispatch } from "react-redux";
import LogisticPartnerAuth from "../../../auth/LogisticPartnerAuth";
import PageSpinner from "../../../common/PageSpinner";
import axios from "axios";
import { BHAREE_BASE_URL_LOCAL } from "../../../../config/config.url";
import { normalizeImages } from "../../../../utils/normalizeImages";

const UserLP = ({ title = "User & Vehicle Info", userId, propUserObj }) => {
  const dispatch = useDispatch();
  const { alert, confirm, DialogModal } = useDialog();
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [userObj, setUserObj] = useState(null);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState({});

  useEffect(() => {
    if (propUserObj) {
      setUserObj(propUserObj);

      const mVehicleTypeDetails = propUserObj?.business_info?.vehicle_type_details
        ? JSON.parse(propUserObj?.business_info?.vehicle_type_details)
        : {};
      setVehicleTypeDetails(mVehicleTypeDetails);
    }
  }, [propUserObj]);

  const onAvailableChange = async () => {
    console.log("handleAvailableChange: userId: ", userId);
    setLoading(true);
    try {
      const response = await axios.get(
        `${BHAREE_BASE_URL_LOCAL}/logistics/changeAvailableStatus/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.jwtToken} `,
          },
        }
      );

      if (response && response?.data) {
        if (response?.data?.success) {
          getLPDetails();
        }
      }
    } catch (error) {
      console.error("Upload error:", error.response || error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const editLP = () => {
    return (
      <Row className="company-info m-0">
        <Row className="heading-div">
          <Col md={6} xs={6} className="m-0 p-0">
            <h5 className="text-uppercase p-0 m-0">
              Logistic Partner: {userObj?.business_info?.business_name}
            </h5>
          </Col>
          <Col md={6} xs={6} className="m-0 p-0 text-end">
            <Button
              className="btn-theme"
              size="sm"
              onClick={() => {
                setIsUpdateMode(true);
              }}
            >
              <i className="bi bi-pencil"></i> Edit
            </Button>
          </Col>
        </Row>
        <hr />
        <h4 className="m-0 p-0 mb-3">Basic Info</h4>
        <Row className="m-0 p-0">
          <Col xs={12} md={6} lg={6} className="p-0">
            <p>
              <span>{"Driver Name:"}</span>
              <span className="mx-2 bold-span"> {userObj?.contact_person_name}</span>
            </p>
            <p>
              <span>{"Driver Email:"}</span>
              <span className="mx-2 bold-span"> {userObj?.email}</span>
            </p>
            <p>
              <span>{"Driver Contact:"}</span>
              <span className="mx-2 bold-span"> {userObj?.mobile_number}</span>
            </p>
            <p>
              <span>{"Driver License Number:"}</span>
              <span className="mx-2 bold-span"> {userObj?.business_info?.driver_license_no}</span>
            </p>
            <p>
              <div className="d-flex align-items-center">
                <span className="me-2 fw-bold">
                  Available:{" "}
                  {userObj?.business_info?.is_available ? (
                    <span className="text-success">✅ Yes</span>
                  ) : (
                    <span className="text-danger">❌ No</span>
                  )}
                </span>
                <Form.Check
                  className="large-switch"
                  type="switch"
                  id={`available-check-user`}
                  checked={userObj?.business_info?.is_available}
                  onChange={(e) => onAvailableChange(userObj.id)}
                />
              </div>
            </p>
            <p>
              <span className="me-2 fw-bold">
                Vehicle Status:{" "}
                {userObj?.vehicle_is_busy ? (
                  <span className="text-danger">❌ Busy. In Transit.</span>
                ) : (
                  <span className="text-success">✅ Free</span>
                )}
              </span>
            </p>
            <p>
              <span>{"Per KM Rate:"}</span>
              <span className="mx-2 bold-span">
                {" "}
                <i className="bi bi-currency-rupee"></i>
                {userObj?.business_info?.per_km_rate}
              </span>
            </p>
            <p>
              <span>{"City:"}</span>
              <span className="mx-2 bold-span">{userObj?.business_info?.city}</span>
            </p>
            <p>
              <span>{"District:"}</span>
              <span className="mx-2 bold-span">{userObj?.business_info?.district}</span>
            </p>
            <p>
              <span>{"State:"}</span>
              <span className="mx-2 bold-span">{userObj?.business_info?.state}</span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={6} className="p-0">
            <p>
              <span>{"Driver License Copy:"}</span>
              <br />
              {(() => {
                if (userObj?.business_info?.driver_license_copy) {
                  return (
                    <Image
                      className="img-fluid px-0 mx-0 mt-2"
                      src={userObj?.business_info?.driver_license_copy}
                      alt="Driver License Copy"
                      style={{ width: "300px" }}
                    />
                  );
                } else {
                  return (
                    <p className="text-danger small px-0 mt-2 m-0">
                      Please upload the driver license copy by clicking on the "Edit" button.
                    </p>
                  );
                }
              })()}
            </p>
          </Col>
        </Row>
        <h4 className="m-0 p-0 mb-3">Vehicle Details</h4>
        <Row className="m-0 p-0">
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Vehicle Owner Name:"}</span>
              <span className="mx-2 bold-span"> {userObj?.business_info?.vehicle_owner_name}</span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Registration Number:"}</span>
              <span className="mx-2 bold-span"> {userObj?.business_info?.vehicle_reg_no}</span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"RC Number:"}</span>
              <span className="mx-2 bold-span"> {userObj?.business_info?.vehicle_rc_no}</span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Make & Model:"}</span>
              <span className="mx-2 bold-span">
                {" "}
                {vehicleTypeDetails?.make + " - " + vehicleTypeDetails?.model ||
                  userObj?.business_info?.vehicle_make}
              </span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Payload Capacity:"}</span>
              <span className="mx-2 bold-span">
                {" "}
                {vehicleTypeDetails?.max_payload ||
                  userObj?.business_info?.vehicle_payload_capacity}{" "}
                kg
              </span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Mileage:"}</span>
              <span className="mx-2 bold-span"> {vehicleTypeDetails?.mileage}</span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Fuel:"}</span>
              <span className="mx-2 bold-span"> {vehicleTypeDetails?.fuel}</span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Body Type:"}</span>
              <span className="mx-2 bold-span"> {userObj?.business_info?.vehicle_body_type}</span>
            </p>
          </Col>
        </Row>
        <h4 className="m-0 p-0 mb-3">Vehicle Documents</h4>
        <Row className="m-0 p-0">
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Vehicle RC Copy:"}</span>
              <br />
              {(() => {
                if (userObj?.business_info?.vehicle_rc_copy) {
                  return (
                    <Image
                      className="img-fluid px-0 mx-0 mt-2"
                      src={userObj?.business_info?.vehicle_rc_copy}
                      alt="Driver License Copy"
                      style={{ maxWidth: "90%" }}
                    />
                  );
                } else {
                  return (
                    <p className="text-danger small px-0 mt-2 m-0">
                      Please upload the vehicle RC copy by clicking on the "Edit" button.
                    </p>
                  );
                }
              })()}
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Insurance Copy:"}</span>
              <br />
              {(() => {
                if (userObj?.business_info?.insurance_copy) {
                  return (
                    <Image
                      className="img-fluid px-0 mx-0 mt-2"
                      src={userObj?.business_info?.insurance_copy}
                      alt="Driver License Copy"
                      style={{ maxWidth: "90%" }}
                    />
                  );
                } else {
                  return (
                    <p className="text-danger small px-0 mt-2 m-0">
                      Please upload the Insurance copy by clicking on the "Edit" button.
                    </p>
                  );
                }
              })()}
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Transport Permit Copy:"}</span>
              <br />
              {(() => {
                if (userObj?.business_info?.transport_permit_copy) {
                  return (
                    <Image
                      className="img-fluid px-0 mx-0 mt-2"
                      src={userObj?.business_info?.transport_permit_copy}
                      alt="Driver License Copy"
                      style={{ maxWidth: "90%" }}
                    />
                  );
                } else {
                  return (
                    <p className="text-danger small px-0 mt-2 m-0">
                      Please upload the Transport Permit copy by clicking on the "Edit" button.
                    </p>
                  );
                }
              })()}
            </p>
          </Col>
        </Row>
        <h4 className="m-0 p-0 mb-3">Vehicle Images</h4>
        <Row className="m-0 p-0">
          <Col xs={12} md={12} lg={12} className="p-0">
            <div className="vehicle-images-gallery">
              {Array.isArray(userObj?.business_info?.vehicle_images)
                ? userObj?.business_info?.vehicle_images.map((imgUrl, imgIndex) => (
                    <a key={imgIndex} href={imgUrl} target="_blank" rel="noopener noreferrer">
                      <Image src={imgUrl} thumbnail className="vehicle-img" />
                    </a>
                  ))
                : (() => {
                    try {
                      const parsed = normalizeImages(userObj?.business_info?.vehicle_images);
                      return parsed.map((imgUrl, imgIndex) => (
                        <a key={imgIndex} href={imgUrl} target="_blank" rel="noopener noreferrer">
                          <Image src={imgUrl} thumbnail className="vehicle-img" />
                        </a>
                      ));
                    } catch {
                      return <p className="text-muted">No images available</p>;
                    }
                  })()}
            </div>
          </Col>
        </Row>
      </Row>
    );
  };

  const getLPDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(BHAREE_BASE_URL_LOCAL + "/logistics/" + userId, {
        headers: {
          Authorization: `Bearer ${localStorage.jwtToken}`,
        },
      });
      console.log("getLPDetails: ", response);
      if (response && response?.data) {
        if (response?.data?.success) {
          setUserObj(response?.data?.data);

          const mVehicleTypeDetails = response?.data?.data?.business_info?.vehicle_type_details
            ? JSON.parse(response?.data?.data?.business_info?.vehicle_type_details)
            : {};
          setVehicleTypeDetails(mVehicleTypeDetails);
        }
      }
      return response;
    } catch (error) {
      console.error("Upload error:", error.response || error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {DialogModal}
      {loading && <PageSpinner />}
      {(() => {
        if (isUpdateMode) {
          return (
            <LogisticPartnerAuth
              lpDetails={userObj}
              closeButtonTitle="View"
              closeButtonFunction={() => {
                setIsUpdateMode(false);
                getLPDetails();
              }}
            />
          );
        } else {
          return editLP();
        }
      })()}
    </>
  );
};

export default UserLP;
